import React from 'react';

const UserSync = ({ width, height, ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M5.87711 7.20834C7.15942 7.20834 8.17393 6.27107 8.17393 4.91152V3.76826C8.17393 2.4087 7.15942 1.47144 5.87711 1.47144C4.59481 1.47144 3.58029 2.4087 3.58029 3.76826V4.91667C3.58029 6.27107 4.59481 7.20834 5.87711 7.20834Z"
      stroke="#3E3E40"
    />
    <path
      d="M1.00049 13.4603V11.1635C1.00049 11.009 1.02624 10.8596 1.07774 10.7154C1.44337 9.65455 2.81838 9.16017 3.79684 8.89238C4.45602 8.71214 5.14094 8.57824 5.82587 8.61429"
      stroke="#3E3E40"
    />
    <path d="M12.0006 8.18677V9.55662H10.6359" stroke="#3E3E40" />
    <path
      d="M12.0004 9.55654C11.6039 8.65018 10.7799 8.0116 9.72422 8.0116C8.66851 8.0116 7.76214 8.65018 7.3656 9.55654"
      stroke="#3E3E40"
    />
    <path d="M7.3656 12.9813V11.6166H8.73545" stroke="#3E3E40" />
    <path
      d="M7.3656 11.6166C7.76214 12.5229 8.58611 13.1615 9.64182 13.1615C10.6975 13.1615 11.6039 12.5229 12.0004 11.6166"
      stroke="#3E3E40"
    />
  </svg>
);

export default UserSync;
